class ConsumerPaymentMethodsController  {
    constructor(createAutoQuery, consumerPaymentMethodPrompt) {
        let options = {
            url: 'QueryConsumerPaymentMethods.json?ConsumerId=' + this.consumerId,
            pageSize: 24,
            sortBy:'Name',
            append:false,
            autoLoad:true,
            sortOptions:{
                'Name': 'Name: A to Z',
                '-Name': 'Name: Z to A',
                'Type': 'Provider: A to Z',
                '-Type': 'Provider: Z to A',
                'Expires': 'Expires: Newest',
                '-Expires': 'Expires: Oldest',
                'Address': 'Address: A to Z',
                '-Address': 'Address: Z to A',
                'Address2': 'Address2: A to Z',
                '-Address2': 'Address2: Z to A',
                'City': 'City: A to Z',
                '-City': 'City: Z to A',
                'State': 'State: A to Z',
                '-State': 'State: Z to A',
                'Zip': 'Zip: 1 to 9',
                '-Zip': 'Zip: 9 to 1'
            }
        };
        this.query = createAutoQuery(options);
        this.prompt = consumerPaymentMethodPrompt;
    }
    load(){return this.query.load.apply(this.query, arguments);}
    add(){return this.prompt.add(Object.assign({name: this.container.consumer.displayName, consumerId: this.consumerId}, this.container.consumer)).then(() => this.load(true));}
    edit(model){return this.prompt.edit(model).then(() => this.load(true));}
    delete(model){return this.prompt.delete(model).then(() => this.load(true));}

    $onDestroy() {
        this.query.dispose();
    }
}

class ConsumerPaymentMethods{
    constructor(){
        this.require= {
            container: '^consumerContainer'
        };
        this.bindings= {
            consumerId: '@'
        };
        this.controller = ConsumerPaymentMethodsController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumer-payment-methods.html'
    }
}

angular.module('emun.consumer').component('consumerPaymentMethods', new ConsumerPaymentMethods());

export default ConsumerPaymentMethods;